const apiMap = {
  localhost: 'https://ucenter.yunkeduntest.com',
  'management.schoolweb.yunkeduntest.com': 'https://ucenter.yunkeduntest.com',
  'management.schoolweb.qinglukeji.cn': 'https://ucenter.yunkedun.com',
};

const baseUrl = apiMap[window.location.hostname]; // 总校区api地址，分校区api根据校区接口返回的domain

export default baseUrl;



// WEBPACK FOOTER //
// ./src/utils/api.js